import { Component, ChangeDetectionStrategy } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixTextComponent } from "../../prefix-text.component";
import { TemplateTextComponent } from "../../templates/template-text/template-text.component";
import { MaxLength } from "../../types/MaxLength";

@Component({
  selector: "app-prefix-om4",
  imports: [TemplateTextComponent],
  templateUrl: "./prefix-om4.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./prefix-om4.component.less",
})
export class PrefixOm4Component extends PrefixTextComponent {
  public maxlength: MaxLength;

  public constructor() {
    super();
    this.maxlength = 384;
    this.required = true;
    this.characters = ALLOWED_CHARACTERS["om4"];
  }
}
